import React, { useState, useEffect, useRef } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import moment from "moment";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import TransactionReport from "./transaction_report";
import KioskUsageReport from "./kiosk_usage_report";
import KioskOperationalReport from "./kiosk_operational_report";
import FinancialReconciliationReport from "./financial_reconciliation_report";

const UserActivityReport = () => {
  const exportCSVRef = useRef(() => {});

  const [globalFilter, setGlobalFilter] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [fromDate, setFromDate] = useState(moment().startOf("month").toDate());
  const [toDate, setToDate] = useState(moment().endOf("month").toDate());

  const resetFilters = () => {
    setGlobalFilter("");
    setFromDate(moment().startOf("month").toDate());
    setToDate(moment().endOf("month").toDate());
  };

  return (
    <>
      <div className="grid align-items-center mb-3 p-2 justify-content-between gap-3">
        <div>
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              className="mbl_view"
              placeholder="Search"
              value={globalFilter}
              onChange={(e) => setGlobalFilter(e.target.value)}
            />
          </span>
        </div>
        <div className="grid gap-3">
          <Calendar
            placeholder="Select From Date"
            showIcon
            value={fromDate}
            onChange={(e) => setFromDate(e.value)}
            maxDate={toDate}
          />
          <Calendar
            placeholder="Select To Date"
            showIcon
            value={toDate}
            onChange={(e) => setToDate(e.value)}
            minDate={fromDate}
          />
          <Button
            className="custom-btn export-excel secondary-button"
            label="Export Excel"
            icon="pi pi-window-maximize"
            onClick={() => exportCSVRef.current()}
          />
        </div>
      </div>
      <TabView
        activeIndex={activeTab}
        onTabChange={(e) => {
          setActiveTab(e.index);
          resetFilters();
        }}
      >
        <TabPanel header="Transaction Report">
          <TransactionReport
            exportCSV={exportCSVRef}
            globalFilter={globalFilter}
            fromDate={fromDate}
            toDate={toDate}
          />
        </TabPanel>
        <TabPanel header="KIOSK Usage Report">
          <KioskUsageReport
            exportCSV={exportCSVRef}
            globalFilter={globalFilter}
            fromDate={fromDate}
            toDate={toDate}
          />
        </TabPanel>
        <TabPanel header="Operational Report">
          <KioskOperationalReport
            exportCSV={exportCSVRef}
            globalFilter={globalFilter}
            fromDate={fromDate}
            toDate={toDate}
          />
        </TabPanel>
        <TabPanel header="Financial Reconciliation">
          <FinancialReconciliationReport
            exportCSV={exportCSVRef}
            globalFilter={globalFilter}
            fromDate={fromDate}
            toDate={toDate}
          />
        </TabPanel>
      </TabView>
    </>
  );
};

export default UserActivityReport;
